/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: eWV8ME8zaoyc
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicProgressBar.module.css"; // plasmic-import: eWV8ME8zaoyc/css

createPlasmicElementProxy;

export const PlasmicProgressBar__VariantProps = new Array("_6Steps");

export const PlasmicProgressBar__ArgProps = new Array();

const $$ = {};

function PlasmicProgressBar__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "_6Steps",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props._6Steps
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.root_6Steps__0Of6]: hasVariant($state, "_6Steps", "_0Of6"),
          [sty.root_6Steps__1Of6]: hasVariant($state, "_6Steps", "_1Of6")
        }
      )}
    >
      <div
        data-plasmic-name={"st1"}
        data-plasmic-override={overrides.st1}
        className={classNames(projectcss.all, sty.st1, {
          [sty.st1_6Steps__0Of6]: hasVariant($state, "_6Steps", "_0Of6"),
          [sty.st1_6Steps__1Of6]: hasVariant($state, "_6Steps", "_1Of6"),
          [sty.st1_6Steps__2Of6]: hasVariant($state, "_6Steps", "_2Of6"),
          [sty.st1_6Steps__3Of6]: hasVariant($state, "_6Steps", "_3Of6"),
          [sty.st1_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st1_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st1_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st2"}
        data-plasmic-override={overrides.st2}
        className={classNames(projectcss.all, sty.st2, {
          [sty.st2_6Steps__0Of6]: hasVariant($state, "_6Steps", "_0Of6"),
          [sty.st2_6Steps__1Of6]: hasVariant($state, "_6Steps", "_1Of6"),
          [sty.st2_6Steps__2Of6]: hasVariant($state, "_6Steps", "_2Of6"),
          [sty.st2_6Steps__3Of6]: hasVariant($state, "_6Steps", "_3Of6"),
          [sty.st2_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st2_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st2_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st3"}
        data-plasmic-override={overrides.st3}
        className={classNames(projectcss.all, sty.st3, {
          [sty.st3_6Steps__2Of6]: hasVariant($state, "_6Steps", "_2Of6"),
          [sty.st3_6Steps__3Of6]: hasVariant($state, "_6Steps", "_3Of6"),
          [sty.st3_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st3_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st3_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st4"}
        data-plasmic-override={overrides.st4}
        className={classNames(projectcss.all, sty.st4, {
          [sty.st4_6Steps__3Of6]: hasVariant($state, "_6Steps", "_3Of6"),
          [sty.st4_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st4_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st4_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st5"}
        data-plasmic-override={overrides.st5}
        className={classNames(projectcss.all, sty.st5, {
          [sty.st5_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st5_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st5_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st6"}
        data-plasmic-override={overrides.st6}
        className={classNames(projectcss.all, sty.st6, {
          [sty.st6_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st6_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st7"}
        data-plasmic-override={overrides.st7}
        className={classNames(projectcss.all, sty.st7, {
          [sty.st7_6Steps__0Of6]: hasVariant($state, "_6Steps", "_0Of6"),
          [sty.st7_6Steps__1Of6]: hasVariant($state, "_6Steps", "_1Of6"),
          [sty.st7_6Steps__2Of6]: hasVariant($state, "_6Steps", "_2Of6"),
          [sty.st7_6Steps__3Of6]: hasVariant($state, "_6Steps", "_3Of6"),
          [sty.st7_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st7_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st7_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st8"}
        data-plasmic-override={overrides.st8}
        className={classNames(projectcss.all, sty.st8, {
          [sty.st8_6Steps__0Of6]: hasVariant($state, "_6Steps", "_0Of6"),
          [sty.st8_6Steps__1Of6]: hasVariant($state, "_6Steps", "_1Of6"),
          [sty.st8_6Steps__2Of6]: hasVariant($state, "_6Steps", "_2Of6"),
          [sty.st8_6Steps__3Of6]: hasVariant($state, "_6Steps", "_3Of6"),
          [sty.st8_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st8_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st8_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st9"}
        data-plasmic-override={overrides.st9}
        className={classNames(projectcss.all, sty.st9, {
          [sty.st9_6Steps__0Of6]: hasVariant($state, "_6Steps", "_0Of6"),
          [sty.st9_6Steps__1Of6]: hasVariant($state, "_6Steps", "_1Of6"),
          [sty.st9_6Steps__2Of6]: hasVariant($state, "_6Steps", "_2Of6"),
          [sty.st9_6Steps__3Of6]: hasVariant($state, "_6Steps", "_3Of6"),
          [sty.st9_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st9_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st9_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />

      <div
        data-plasmic-name={"st10"}
        data-plasmic-override={overrides.st10}
        className={classNames(projectcss.all, sty.st10, {
          [sty.st10_6Steps__0Of6]: hasVariant($state, "_6Steps", "_0Of6"),
          [sty.st10_6Steps__1Of6]: hasVariant($state, "_6Steps", "_1Of6"),
          [sty.st10_6Steps__2Of6]: hasVariant($state, "_6Steps", "_2Of6"),
          [sty.st10_6Steps__3Of6]: hasVariant($state, "_6Steps", "_3Of6"),
          [sty.st10_6Steps__4Of6]: hasVariant($state, "_6Steps", "_4Of6"),
          [sty.st10_6Steps__5Of6]: hasVariant($state, "_6Steps", "_5Of6"),
          [sty.st10_6Steps__6Of6]: hasVariant($state, "_6Steps", "_6Of6")
        })}
      />
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "st1",
    "st2",
    "st3",
    "st4",
    "st5",
    "st6",
    "st7",
    "st8",
    "st9",
    "st10"
  ],

  st1: ["st1"],
  st2: ["st2"],
  st3: ["st3"],
  st4: ["st4"],
  st5: ["st5"],
  st6: ["st6"],
  st7: ["st7"],
  st8: ["st8"],
  st9: ["st9"],
  st10: ["st10"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicProgressBar__ArgProps,
          internalVariantPropNames: PlasmicProgressBar__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicProgressBar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProgressBar";
  } else {
    func.displayName = `PlasmicProgressBar.${nodeName}`;
  }
  return func;
}

export const PlasmicProgressBar = Object.assign(
  // Top-level PlasmicProgressBar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    st1: makeNodeComponent("st1"),
    st2: makeNodeComponent("st2"),
    st3: makeNodeComponent("st3"),
    st4: makeNodeComponent("st4"),
    st5: makeNodeComponent("st5"),
    st6: makeNodeComponent("st6"),
    st7: makeNodeComponent("st7"),
    st8: makeNodeComponent("st8"),
    st9: makeNodeComponent("st9"),
    st10: makeNodeComponent("st10"),
    // Metadata about props expected for PlasmicProgressBar
    internalVariantProps: PlasmicProgressBar__VariantProps,
    internalArgProps: PlasmicProgressBar__ArgProps
  }
);

export default PlasmicProgressBar;
/* prettier-ignore-end */
